import { IFareReportParams, IFreeMarketAnalysisParams, IPdfBase64Params } from '@/interfaces/api/fareOptimizer'
import ApiService from '../api.service'

const fareOptimizerResource = {
  extractPdfData: (params: IPdfBase64Params) => ApiService.post('/v1/pdf/pdf_extract', params),
  freeMarketAnalysis: (params: IFreeMarketAnalysisParams) => ApiService.post('/v1/tariff_optimizer', params),
  generateReport: (params: IFareReportParams) => ApiService.postBlob('/v1/fare_optimizer/report', params),
}

export default fareOptimizerResource
